import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Add as AddIcon, List as ListIcon } from '@mui/icons-material';

interface ChatEmptyStateProps {
  onNewInvestigation: () => void;
  onOpenInvestigations: () => void;
}

// With no investigation selected the side panels may all be closed (always on a phone), so the
// way forward is offered here. A new investigation goes through its dialog, which asks for the
// accounts before the first message; there is deliberately no message box here.
const ChatEmptyState: React.FC<ChatEmptyStateProps> = ({ onNewInvestigation, onOpenInvestigations }) => (
  <Box
    sx={{
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      p: 2,
    }}
  >
    <Box>
      <Typography variant="h5" gutterBottom color="text.secondary">
        No conversation selected
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Start a new conversation to begin
      </Typography>
      <Box sx={{ mt: 3, display: 'flex', flexWrap: 'wrap', gap: 1.5, justifyContent: 'center' }}>
        <Button variant="contained" startIcon={<AddIcon />} onClick={onNewInvestigation}>
          New investigation
        </Button>
        <Button variant="outlined" startIcon={<ListIcon />} onClick={onOpenInvestigations}>
          Open investigations
        </Button>
      </Box>
    </Box>
  </Box>
);

export default ChatEmptyState;
